var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPerp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1661 7.12604C17.5108 7.35581 17.6039 7.82146 17.3741 8.1661L12.817 15.0019L10.3314 12.0192L7.38284 16.6527C7.16046 17.0022 6.69689 17.1052 6.34744 16.8828C5.99798 16.6604 5.89497 16.1969 6.11735 15.8474L10.1688 9.48093L12.6832 12.4983L16.1261 7.33405C16.3558 6.98941 16.8215 6.89628 17.1661 7.12604Z",
    fill: "#EA7E68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPerp);
export default __webpack_public_path__ + "static/media/icn-perp.65be96019d4529b36a4003db52fbbeca.svg";
export { ForwardRef as ReactComponent };